import { render, staticRenderFns } from "./letter-batch-print.vue?vue&type=template&id=08f13f6b"
import script from "./letter-batch-print.vue?vue&type=script&lang=ts"
export * from "./letter-batch-print.vue?vue&type=script&lang=ts"
import style0 from "./letter-batch-print.vue?vue&type=style&index=0&id=08f13f6b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports